module.exports = __webpack_public_path__ + "img/Enscape_2020-09-22-10-50-29_Aerial-Overview.18078366.jpg";